import { ConsoleLoggingStrategy } from "@com.mgmtp.a12.utils/utils-logging";
import { LogLevel } from "@com.mgmtp.a12.utils/utils-logging/api";
import { Settings } from "@com.mgmtp.a12.utils/utils-logging/lib/Settings";

import { isProduction } from "./general";

if (isProduction) {
	Settings.LogStrategy = new ConsoleLoggingStrategy(console, LogLevel.ERROR);
} else {
	Settings.LogStrategy = new ConsoleLoggingStrategy(console, LogLevel.LOG);
}
